import {newsletterSection} from '../globals/newsletter';
import {register} from '../vendor/theme-scripts/theme-sections';

register('newsletter', newsletterSection);
